import React from "react";
import "../scss/Header.scss";
import logo from "../Images/logo.png";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useGlobalContext } from "../components/Context";

const Header = () => {
	const { open, openBurger } = useGlobalContext();
	// const openBurger = useGlobalContext();
	const { pathname } = useLocation();

	return (
		<>
			<div
				className="header"
				style={{
					backgroundImage:
						pathname === "/"
							? "linear-gradient(105.32deg, #D2E7FF -1.05%, #F2F8FF 78.81%)"
							: "linear-gradient(105.32deg, #FFFFFF -1.05%, #FFFFFF 78.81%)",
				}}>
				<div className="header__container">
					<div className="header__logo">
						<img src={logo} alt="logo" />
					</div>

					<div
						className={!open ? "header__left header__active" : "header__left"}>
						<div className="header__links">
							<ul className="header__link-wrapper">
								<NavLink to="/" onClick={openBurger}>
									<li>Home</li>
								</NavLink>
								<NavLink to="/market-place" onClick={openBurger}>
									<li>Market</li>
								</NavLink>
								<NavLink to="/rates" onClick={openBurger}>
									<li>Rate</li>
								</NavLink>
								<NavLink to="/partners" onClick={openBurger}>
									<li>Partners</li>
								</NavLink>

								<NavLink to="/about-us" onClick={openBurger}>
									<li>About Us</li>
								</NavLink>
							</ul>
						</div>

						<div className="header__buttons">
							<Link to="/" onClick={openBurger}>
								<button className="header__login">Log In</button>
							</Link>

							<Link to="/" onClick={openBurger}>
								<button className="header__create">Create Account</button>
							</Link>
						</div>
					</div>

					<div className="burger" onClick={openBurger}>
						<div className={open ? "btn active" : "btn not-active"}>
							<span className="spam"></span>
							<span className="spam"></span>
							<span className="spam"></span>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Header;
